import PhoneCall from "./phone-call";
import axios from "axios";
import store from "@/store";

class OutboundCall extends PhoneCall {
	constructor(callInstance, parameters) {
		store.commit("voice/setLoadingCallDetails", true);
		super(callInstance, false, parameters);
		this.direction = "outbound";
	}

	start = () => {
		const durationInt = setInterval(() => {
			const status = this.callInstance?.status();

			if (status === "ringing" || status === "open") {
				clearInterval(durationInt);
				this.countDuration();
			} else if (status === "closed") {
				clearInterval(durationInt);
			}
		}, 1000);

		let retry = 0;

		const checkStatus = async () => {
			const status = this.callInstance?.status();

			if (status === "closed") {
				this.answered();
				store.commit("voice/setLoadingCallDetails", false);
				return;
			}

			if (status === "connecting" || status === "ringing" || status === "open") {
				try {
					if (this.callSid) {
						const { data: call } = await axios.get(`/voice/v1/calls/sid/${this.callSid}`);

						if (call?.id && !this.callDetails?.id) {
							this.callDetails.id = call.id;
							store.commit("voice/setCallDetails", {
								...this.callDetails,
								id: call.id,
								patientName: call.patientName?.length ? call.patientName : this.callDetails.patientName,
								businessName: call.businessName?.length ? call.businessName : this.callDetails.businessName
							});
							store.commit("voice/setLoadingCallDetails", false);
						}

						// Handle answered call
						if (call?.answeredAt) {
							this.callDetails.id = call.id;
							this.answered();
							return;
						}
					} else {
						store.commit("voice/setLoadingCallDetails", false);
					}
				} catch (err) {
					if (retry++ > 15) {
						store.commit("voice/setLoadingCallDetails", false);
						this.hangUp();
						console.error("Failed to fetch call details after 10 attempts.", err);
						return;
					}
				}
			}

			// Use requestAnimationFrame instead of setTimeout for better performance
			// when browser tab is visible, falls back to setTimeout when not
			if (typeof window !== "undefined" && window.requestAnimationFrame) {
				requestAnimationFrame(() => setTimeout(checkStatus, 1000));
			} else {
				setTimeout(checkStatus, 1000);
			}
		};

		checkStatus();
	};

	static from(callInstance, parameters) {
		return new OutboundCall(callInstance, parameters);
	}
}

export default OutboundCall;
